import { ModuleManager } from './ModuleManager';
import { PingPongModule } from './ping-pong';
import { RoomsModule } from './rooms';
import { StateSynchronizer } from './state/sync-state';
import EventTarget from './util/event-target';

const DEFAULT_SERVER_URL = 'ws://localhost:9090';
const SERVER = '$server';

export class SyncClient extends EventTarget {
  constructor(config = {}) {
    super();

    this.socket = new WebSocket(config.serverUrl || DEFAULT_SERVER_URL);
    this.socket.onmessage = (event) => this.handleMessage(event.data);

    // Will resolve once a connection has been established to the server.
    this.whenOpen = new Promise((resolve) => {
      this.socket.onopen = resolve;
      this.socket.onerror = (error) => {
        this.dispatchEvent({ type: 'error', error });
      };
      this.socket.onclose = () => {
        this.dispatchEvent({ type: 'error', error: 'closed by server' });
      };
    });

    // An alternative to the connect event.  Will resolve once sync-client is ready to be used.
    this.whenReady = new Promise((resolve) => {
      this.onReady = () => resolve(this);
    });

    this.modules = new ModuleManager(this);
    this.modules.register([RoomsModule, StateSynchronizer, PingPongModule]);

    this.whenOpen
      .then(() => {
        this.onReady();
        this.dispatchEvent({ type: 'connect' });
      })
      .catch((error) => {
        this.dispatchEvent({ type: 'error', error });
      });
  }

  sendPacket(destination, type, payload = null) {
    try {
      this.socket.send(JSON.stringify({ destination, type, payload }));
    } catch (error) {
      this.dispatchEvent({ type: 'error', error });
    }
  }

  set username(username) {
    this.sendPacket(SERVER, 'IDENTIFY', { username });
  }

  handleMessage(message) {
    const packet = JSON.parse(message);

    if (packet.source === SERVER && packet.type === 'IDENTITY') {
      this.id = packet.payload.id;
    }

    this.dispatchEvent({ type: 'packet', packet });

    this.modules.onPacketReceived(packet);
  }
}
